import { render, staticRenderFns } from "./AdminInstitutionForm.vue?vue&type=template&id=46b5de08&scoped=true&"
import script from "./AdminInstitutionForm.vue?vue&type=script&lang=js&"
export * from "./AdminInstitutionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b5de08",
  null
  
)

export default component.exports